<template>
  <div>
    <a-drawer title="文章详情" :placement="'right'" :visible="articleVis" :width="1100" @close="onClose">
      <div class="detail">
        <div class="toolbar">
          <div class="category">
            <a-tag :color="catid == item.catid ? '#108ee9' : 'blue'" v-for="(item, index) in cateName" :key="index">{{
              item.catname }}</a-tag>
          </div>
          <div class="menu edit" @click="edit">
            <a-icon type="edit" theme="twoTone" twoToneColor="#52c41a" />编辑
          </div>
          <div class="menu delete" @click="del">
            <a-icon type="delete" theme="twoTone" twoToneColor="#FF6E32" />删除
          </div>
          <a-popconfirm placement="bottomRight" okText="通过" cancelText="拒审" @confirm="confirm" @cancel="auditrecover"
            v-if="article.status < 100 && article.status > 1">
            <template slot="title">
              <p>确认审核该文章吗？</p>
            </template>
            <div class="menu"><a-icon type="solution" />审核</div>
          </a-popconfirm>
          <div class="menu" style="width: 100px" v-else-if="article.status == 100" @click="auditrecover()">
            <a-icon type="solution" />退稿
          </div>
          <div class="menu" :class="{ current: index == 4 }" @click="logShow" v-if="audit != ''">
            <a-icon type="file-text" />日志
          </div>
          <div class="menu" @click="showHistory()" v-if="historyList.length > 0">
            <a-icon type="file-exclamation" />历史
          </div>
          <div class="menu" v-if="article.status == 100" @click="getLink()">
            <a-icon type="link" />链接
          </div>
          <div class="menu" @click="previewlink()" v-else>
            <a-icon type="eye" />预览
          </div>
          <div class="menu" style="width: 130px; padding: 0 10px" v-if="article.status == 100">
            <span @click="showPush">
              <a-icon type="branches" style="color: #7546c9" />推送至长江云
            </span>

            <a-card class="push-nav" :class="{ shownav: pushnav == true }" hoverable>
              <a-divider style="margin: 10px 0; font-size: 12px; font-weight: normal">栏目选择</a-divider>
              <div class="catelists">
                <div v-for="(item, index) in cjyCate" class="cate" @click="checkCate(item)" :key="index">
                  {{ item.name }}
                  <div style="float: right" v-if="selectCate.indexOf(parseInt(item.id)) > -1">
                    <a-icon type="check" style="color: #52c41a" />
                  </div>
                  <!--                            <a-icon type="check" theme="twoTone" twoToneColor="#52c41a" />-->
                </div>
              </div>
              <div class="cate catesubmit" @click="pushcjy">推送</div>
            </a-card>
          </div>
          <div class="menu" style="width: 140px" v-if="userInfo.site_id === '21' && article.fromid > '4000000'"
            @click="syncCloud">
            <span> <a-icon type="link" />手动同步长江云 </span>
          </div>
          <div class="menu" style="width: 140px"
            v-if="userInfo.site_id === '21' && article.fromid < '4000000' && article.fromid > 0">
            <span @click="showSync"> <a-icon type="link" />手动同步长江云 </span>
            <a-card class="old-sync" hoverable :class="{ shownav: syncnav == true }">
              <a-divider style="margin: 10px 0; font-size: 12px; font-weight: normal">手动同步</a-divider>
              <div>
                <a-input v-model:value="oldFormid" placeholder="请输入长江云文章id" />
              </div>
              <div class="cate catesubmit-sync" @click="syncOldCloud">同步</div>
            </a-card>
          </div>
          <div class="menu" style="width: 100px; padding: 0 10px" @click="showlink" v-if="contenturl != ''">
            <a-icon type="link" />查看链接
          </div>

          <a-modal title="推送至第三方平台" centered v-model="modal2Visible" @ok="okToPublishThirdPlatform">
            <a-checkbox-group @change="chooseShareChannel" :value="defaultShareChannelValue">
              <a-checkbox v-for="(item, id) in shareChannel" :key="id" :value="1 + id">{{ item }}</a-checkbox>
            </a-checkbox-group>
          </a-modal>
        </div>
        <div v-if="article.title != 'undefined' && article.title != ''">
          <div class="title">
            <h1>{{ article.title }}</h1>
          </div>
          <div class="subtitle" v-if="article.subtitle != 'undefined'">
            <h3>{{ article.subtitle }}</h3>
          </div>
          <div class="info">
            <span>
              文章ID：
              <code>{{ article.id }}</code>
            </span>
            <span>
              <a-dropdown :trigger="['click']">
                <a class="ant-dropdown-link" @click.prevent>
                  所属栏目
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay" @click="handleMenuClick">
                  <a-menu-item :key="index" v-for="(item, index) in cateName">
                    {{ item.catname }}
                    <code>{{ item.catid }}</code>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
            <span v-if="article.adduser">作者：{{ article.adduser }}</span>
            <span>发布时间：{{ article.pubtime }}</span>
            <span v-if="article.comefrom != ''">文章来源：{{ article.comefrom }}</span>
            <span v-if="article.comefrom == ''">文章来源：无</span>
            <span>文章访问数量：{{ article.readcount }}</span>
          </div>
          <div>
            <video v-if="article.attach != ''" width="400" height="300" class="video" poster controls preload
              ref="video"></video>
          </div>
          <div v-if="article.linkurl" style="margin: 50px">
            <a-button block @click="openlink">打开外部链接</a-button>
          </div>
          <div class="content" v-html="article.content" v-else></div>
        </div>
        <div style="
            width: 100%;
            height: 400px;
            text-align: center;
            line-height: 400px;
          " v-else>
          <a-spin size="large" tip="数据加载中..." />
        </div>
      </div>

      <div class="logs" v-show="showLog">
        <a-card hoverable>
          <a-timeline class="log-content">
            <a-timeline-item color="green" v-for="(item, index) in audit" :key="index">
              <span v-if="item.result">{{ item.truename }} 于 {{ item.addtime }} 操作了稿件</span>
            </a-timeline-item>
          </a-timeline>
        </a-card>
      </div>
      <div class="hist" v-show="history">
        <a-card hoverable>
          <a-timeline class="log-content">
            <a-timeline-item color="green" v-for="(item, index) in historyList" :key="index">
              <span>操作时间：{{ item.updateTime.substring(0, 10) }} 操作人：{{
                item.username
              }}</span>
              <a style="margin-left: 15px; color: #40a9ff" @click="pushContrast(item.history_id)">对比</a>
              <a-popconfirm title="版本回退只会恢复文章的标题、副标题、来源、内容、摘要、标题图、外链、关键词,且文章状态会退为草稿，已审核的文章无法回滚" ok-text="确定"
                cancel-text="取消" @confirm="rollback(item.history_id)">
                <a style="margin-left: 5px; color: red">回滚</a>
              </a-popconfirm>
            </a-timeline-item>
          </a-timeline>
        </a-card>
      </div>
      <a-modal title="撤销审核" :visible="visible" @ok="confirmAudit" @cancel="visible = false">
        <p>
          若文章已发布，撤审操作将会导致该文章下线，如确定操作请填写操作理由
        </p>
        <p>
          <a-textarea v-model="reason" placeholder="请填写操作理由" :autosize="{ minRows: 2, maxRows: 6 }"
            @keyup.enter="confirmAudit" />
        </p>
      </a-modal>
    </a-drawer>
  </div>
</template>

<script>
export default {
  name: 'Preview',
  data() {
    return {
      cjyCate: [],
      lists: [],
      currentId: 0,
      loading: false,
      showLog: false,
      index: 0,
      article: {},
      suggestion: '无',
      modal2Visible: false,
      shareChannel: ['微信公众号', '微博公众号', '百家号', '企鹅号'],
      defaultShareChannelValue: [],
      userInfo: {},
      audit: [],
      visible: false,
      reason: '',
      pushnav: false,
      selectCate: [],
      contenturl: '',
      cateName: [],
      catevisible: false,
      history: false,
      historyList: [],
      oldFormid: null,
      syncnav: false
    };
  },
  props: ['catesingle', 'articleId', 'articleVis', 'catid'],
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('siteinfo'));
    this.getCjyCate();
  },
  watch: {
    articleVis: {
      handler: function (value) {
        // console.log(value);
        if (value) {
          this.loadDetail(this.articleId);
        }
        // if (value != 0) {
        //   this.loadDetail(value);
        // }
      }
    }
  },
  methods: {
    handleMenuClick() { },
    //预览
    getLink() {
      let siteLists = JSON.parse(localStorage.getItem('siteLists'));
      let domain = '';
      for (let item of siteLists) {
        if (item.siteid == this.userInfo.site_id) {
          domain = item.domain;
        }
      }
      if (domain != '') {
        domain +=
          '/content/show?catid=' +
          this.article.catid[0] +
          '&newsid=' +
          this.article.id;
      }
      this.$confirm({
        title: '操作成功',
        // JSX support
        content: (
          <div>
            <p>本篇文章的地址是：</p>
            <p>{domain}</p>
          </div>
        ),
        okText: '知道了',
        cancelText: '打开链接',
        closable: true,
        onCancel() {
          window.open(domain);
        }
      });
    },
    async previewlink() {
      let param = {
        id: this.article.id,
        catid: this.article.catid[0]
      };
      let res = await this.$http.post('/api/Snapshot/getDetail', param);
      if (res.data.state == 200) {
        this.$confirm({
          title: '操作成功',
          content: (
            <div>
              <p>预览链接已生成，有效期5分钟，请尽快查看。</p>
              <p>{res.data.data}</p>
            </div>
          ),
          okText: '知道了',
          cancelText: '打开链接',
          closable: true,
          onCancel() {
            window.open(res.data.data);
          }
        });
      } else {
        this.$error({
          title: '错误',
          content: '预览链接生成失败，可能是站点配置错误，请联系管理员。'
        });
      }
    },
    showlink() {
      if (typeof this.contenturl != 'undefined' && this.contenturl != '') {
        const h = this.$createElement;
        this.$info({
          title: '长江云页面链接',
          content: h('div', {}, [h('p', this.contenturl)]),
          onOk() { }
        });
      } else {
        this.$message.warning('文章未被分享至长江云。');
      }
    },
    getCjyCate() {
      this.$http.get('/api/cjyun/categories?pagesize=100').then(res => {
        if (res.data.state == 200) {
          this.cjyCate = res.data.data;
        }
      });
    },
    openlink() {
      window.open(this.article.linkurl);
    },
    chooseShareChannel(value) {
      this.defaultShareChannelValue = value;
    },
    // 确定发布至第三方平台
    okToPublishThirdPlatform() {
      this.modal2Visible = false;
      if (this.defaultShareChannelValue.length) {
        this.$http
          .post('api/ApiThird/thirdInputNews', {
            id: this.article.id,
            tid: this.defaultShareChannelValue.join(','),
            user_id: this.userInfo.userid
          })
          .then(res => {
            if (res.data.state === 200) {
              this.$message.success('推送成功');
              this.defaultShareChannelValue = [];
            }
          })
          .catch(() => {
            this.defaultShareChannelValue = [];
          });
      } else {
        this.defaultShareChannelValue = [];
      }
    },
    showPush() {
      this.pushnav = !this.pushnav;
    },
    showSync() {
      this.syncnav = !this.syncnav;
    },
    confirmAudit() {
      if (this.reason.length < 5) {
        this.$message.warning('请将撤审理由填写完整，撤审理由不得少于5个字');
      } else {
        this.$http
          .post('/api/content/auditrecover', {
            cloudid: this.article.id,
            reason: this.reason
          })
          .then(res => {
            if (res.data.state == 200) {
              this.$message.success('操作成功');
              this.onClose();
              this.onReset();
            } else {
              this.$message.warning(res.data.message);
            }
            this.visible = false;
          });
      }
    },
    auditrecover() {
      this.visible = true;
      this.reason = '';
    },
    del() {
      let that = this;
      this.$confirm({
        title: '确认删除该文章吗?',
        content: '一旦确定删除该文章，你将无法找回',
        onOk() {
          that.$http
            .post('/api/content/clouddel', { ids: that.article.id })
            .then(res => {
              if (res.data.state == 200) {
                that.$message.success('操作成功');
                that.onClose();
                that.onReset();
              }
            });
        },
        onCancel() { }
      });
    },
    cancel() {
      this.$http
        .post('/api/content/auditupdate', {
          cloudid: this.article.id,
          result: 0,
          suggestion: '无'
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('操作成功');
          }
        });
    },
    confirm() {
      this.$http
        .post('/api/content/auditupdate', {
          cloudid: this.article.id,
          result: 1,
          suggestion: '无'
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('操作成功');
            this.onClose();
            this.onReset();
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    edit() {
      if (this.article.status == 100) {
        let that = this;
        this.$confirm({
          title: '操作确认',
          content: '该稿件已发布，编辑需要先撤稿，确定撤稿吗？',
          okText: '撤稿并编辑',
          cancelText: '仅查看',
          onOk() {
            that.$http
              .post('/api/content/auditrecover', {
                cloudid: that.article.id,
                reason: '撤稿并编辑'
              })
              .then(res => {
                if (res.data.state == 200) {
                  console.log(123);
                  that.$message.success('操作成功');
                  window.open('/Main/Article/Add?id=' + that.article.id);
                }
              });
          },
          onCancel() {
            window.open('/Main/Article/Add?id=' + that.article.id);
          }
        });
      } else {
        window.open('/Main/Article/Add?id=' + this.article.id);
      }
    },
    getCatename(cataid) {
      this.cateName = [];
      this.catesingle.forEach(res => {
        if (cataid.indexOf(parseInt(res.catid)) >= 0) {
          this.cateName.push({ catid: res.catid, catname: res.catname });
        }
      });
    },
    loadDetail(id) {
      this.index = 0;
      this.showLog = false;
      this.pushnav = false;
      this.history = false;
      this.contenturl = '';
      this.article = {};
      this.getHistory();
      this.$http.post('/api/content/clouddetail', { id: id }).then(res => {
        this.article = res.data.data;
        this.getCatename(this.article.catid);
        if (this.article.attach != '') {
          this.$refs.video.src = this.article.attach;
        }
        let imgReg = /<img.*?(?:>|\/>)/gi;
        let classReg = /class=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let idReg = /id=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let arr = this.article.content.match(imgReg);
        for (let i in arr) {
          let classMatch = arr[i].match(classReg);
          if (
            classMatch != null &&
            typeof classMatch[1] != 'undefined' &&
            classMatch[1].substr(0, 6) == 'ycrmt_'
          ) {
            let idMatch = arr[i].match(idReg);
            if (
              idMatch != null &&
              typeof idMatch[1] != 'undefined' &&
              idMatch[1] != ''
            ) {
              console.log(classMatch[1]);
              let height = 320;
              if (classMatch[1].substr(-5) == 'audio') height = 40;
              let htmlStr =
                '<iframe src="https://web.ycrmt.cn/play/' +
                classMatch[1].substr(-5) +
                '?id=' +
                idMatch[1] +
                '" frameborder="0" width="480" height="' +
                height +
                '"></iframe>';
              this.article.content = this.article.content.replace(
                new RegExp(arr[i], 'g'),
                htmlStr
              );
            }
          }
        }
        this.article.content = this.article.content.replace(
          /class=/g,
          '_class='
        );
      });
      this.$http.post('/api/cjyun/share', { cloudid: id }).then(res => {
        if (res.data.state == 200) {
          if (
            res.data.data.category === null ||
            typeof res.data.data.category == 'undefined'
          ) {
            this.selectCate = [];
          } else {
            this.selectCate = res.data.data.category;
          }
          this.contenturl = res.data.data.contenturl;
        } else {
          this.selectCate = [];
        }
      });
      this.$http.post('/api/content/auditlist', { cloudid: id }).then(res => {
        if (res.data.state == 200) {
          this.audit = res.data.data;
        } else {
          this.audit = [];
        }
      });
    },
    logShow() {
      this.showLog = !this.showLog;
      this.index = this.showLog ? 4 : 0;
    },
    pushcjy() {
      if (this.selectCate.length > 0) {
        this.pushnav = false;
        let param = {
          cloudid: this.article.id,
          category: this.selectCate.join(',')
        };
        this.$http.post('/api/cjyun/articleupdate', param).then(res => {
          if (res.data.state == 200) {
            this.$message.success('操作成功');
          } else {
            this.$message.warning(res.data.message);
          }
        });
      } else {
        this.$message.warning('你至少要选择一个推送的栏目');
      }
    },
    checkCate(item) {
      let index = this.selectCate.indexOf(parseInt(item.id));
      if (index > -1) {
        this.selectCate.splice(index, 1);
      } else {
        this.selectCate.push(parseInt(item.id));
      }
      this.selectCate = this.selectCate.sort();
    },
    onClose() {
      this.oldFormid = null;
      this.syncnav = false;
      this.$emit('close');
    },
    onReset() {
      this.$emit('reset');
    },
    //查看历史版本
    getHistory() {
      this.historyList = [];
      this.$http
        .post('api/content/historyList', {
          cloudid: this.articleId
        })
        .then(res => {
          if (res.data.state === 200) {
            this.historyList = res.data.data;
          }
        });
    },
    showHistory() {
      this.history = !this.history;
    },
    rollback(id) {
      if (this.article.status === '100') {
        this.$message.error('已审核的文章无法回滚');
        return false;
      } else {
        this.$http.post('api/content/historyRecover', { id }).then(res => {
          if (res.data.state === 200) {
            this.$message.success('回滚成功，请重新打开文章');
            this.onClose();
          } else {
            this.$message.error('回滚失败');
          }
        });
      }
    },
    pushContrast(id) {
      this.$router.push({
        path: '/Main/Article/Contrast',
        query: { id, article_id: this.article.id }
      });
    },

    //手动同步长江云
    syncCloud() {
      this.$http
        .get('https://cjyunsync.ycrmt.cn/sync/content/reSync', {
          params: {
            areaid: 8,
            cloudid: this.article.id
          }
        })
        .then(res => {
          if (res.data.data.state == 200) {
            this.$message.success('同步成功');
          } else {
            this.$message.error('同步失败');
          }
        });
    },
    syncOldCloud() {
      if (!this.oldFormid) {
        return this.$message.error('长江云文章id不能为空');
      }
      this.$http
        .get('https://cjyunsync.ycrmt.cn/sync/content/oldReSync', {
          params: {
            areaid: 8,
            cloudid: this.article.id,
            fromid: this.oldFormid
          }
        })
        .then(res => {
          if (res.data.errno == 0) {
            if (res.data.data.state == 200) {
              this.$message.success('同步成功');
            }
          } else {
            this.$message.error(res.data.errmsg);
          }
        });
    }
  }
};
</script>

<style scoped>
.detail .info span {
  color: #999aa5;
  margin-right: 10px;
}

.detail .content {
  text-indent: 2rem;
  margin-top: 10px;
  font-size: 16px;
  line-height: 28px;
  /*position: absolute;*/
  top: 160px;
  right: 0;
  bottom: 60px;
  left: 0;
}

.detail .content img {
  text-align: center;
}

.detail .delete {
  color: #ff6e32;
}

.detail .edit {
  color: #52c41a;
}

.detail .edit {
  color: #52c41a;
}

.detail .title {
  line-height: 50px;
}

.detail .toolbar .menu:hover,
.detail .toolbar .current {
  background-color: #eeeeee;
}

.push-nav {
  top: -1px;
  left: -10px;
  display: none;
  width: 500px;
  background: #fff;
  z-index: 1000;
  position: relative;
}

.active,
.active>.pubtime,
.active>.user {
  color: #fff;
}

.row .title {
  font-size: 16px;
  min-height: 50px;
}

.row .title i {
  margin-right: 5px;
}

.row .info {
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  color: #c0c4cc;
}

.row .info .pubtime {
  text-align: left;
}

.row .info .user {
  text-align: right;
}

.detail {
  width: 100%;
  position: relative;
}

.detail .toolbar {
  text-align: right;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e8e8e8;
}

.detail .toolbar i {
  margin-right: 5px;
}

.detail .toolbar .menu {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 70px;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
}

.catesubmit,
.catesubmit-sync {
  border-top: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}

.catesubmit-sync {
  height: 40px;
  line-height: 40px;
}

.catesubmit:hover,
.catesubmit-sync:hover {
  color: #fff;
  border-radius: 3px;
  background: #409eff;
}

.option {
  height: 60px;
  line-height: 60px;
  /* border-bottom: 1px solid #e8e8e8; */
}

.option .dropdown {
  width: 100px;
  position: absolute;
  top: 14px;
  text-align: left;
}

.option .dropdown .button {
  padding-left: 10px;
  text-align: left;
  overflow-x: hidden;
}

.option .dropdown .text {
  width: 80px;
  overflow-x: hidden;
  height: 30px;
  line-height: 30px;
  text-overflow: ellipsis;
}

.option .dropdown .icon {
  position: absolute;
  right: 5px;
  top: 10px;
}

.option .search {
  width: 195px;
  position: absolute;
  left: 115px;
  top: 14px;
}

.hist {
  background-color: #fff;
  position: absolute;
  z-index: 999;
  width: 400px;
  height: 500px;
  top: 128px;
  right: 10px;
  overflow-y: auto;
  transition: all 2s;
}

.logs {
  background-color: #fff;
  position: absolute;
  z-index: 999;
  width: 320px;
  top: 128px;
  right: 14px;
  overflow-y: auto;
  transition: all 2s;
  -moz-transition: all 2s;
  /* Firefox 4 */
  -webkit-transition: all 2s;
  /* Safari 和 Chrome */
  -o-transition: all 2s;
  /* Opera */
}

.log-content {
  padding: 10px 0 0 10px;
}

.category {
  line-height: 40px;
  height: 40px;
  position: absolute;
  left: 2px;
  top: 3px;
  color: #1890ff;
  background: #fff;
}

.shownav {
  transition: all 0.3s linear;
  display: block !important;
  /*height: 400px;*/
}

.catelists {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px;
}

.catelists div {
  width: 33.3%;
  text-align: left;
  line-height: 28px;
}

.old-sync {
  top: -1px;
  left: -5px;
  width: 500px;
  display: none;
  padding: 0 16px;
  background: #fff;
  z-index: 1000;
  position: relative;
}
</style>
